import ModelActionsService from 'services/storageModelActions/ModelActionsService';
import { CreateOrderHistoryRequestDTO, OrderHistoryResponseDTO } from 'typings/dto/orderHistory';
import IModelActionsService from './IModelActionsService';

export default class OrderHistoryActionsService
  extends ModelActionsService<OrderHistory, CreateOrderHistoryRequestDTO, OrderHistoryResponseDTO>
  implements IModelActionsService<OrderHistory, CreateOrderHistoryRequestDTO, OrderHistoryResponseDTO> {}
